const BASE = process.env.REACT_APP_API_URL || 'https://api.ryzenforge.com';

const getToken = () => localStorage.getItem('ryzenos_token');

const headers = () => ({
  'Content-Type': 'application/json',
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
});

const req = async (method, path, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: headers(),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

export const api = {
  login:          (email, password)   => req('POST', '/api/auth/login', { email, password }),
  forgotPassword: (email)             => req('POST', '/api/auth/forgot-password', { email }),
  resetPassword:  (email, otp, pass)  => req('POST', '/api/auth/reset-password', { email, otp, newPassword: pass }),
  me:             ()                  => req('GET',  '/api/auth/me'),
  changePassword: (cur, nw)           => req('POST', '/api/auth/change-password', { currentPassword: cur, newPassword: nw }),

  getLeads:    (params = {}) => req('GET', '/api/leads?' + new URLSearchParams(params)),
  createLead:  (data)        => req('POST', '/api/leads', data),
  updateLead:  (id, data)    => req('PUT', `/api/leads/${id}`, data),
  deleteLead:  (id)          => req('DELETE', `/api/leads/${id}`),

  getTeam:      ()           => req('GET', '/api/team'),
  addMember:    (data)       => req('POST', '/api/team', data),
  updateMember: (id, data)   => req('PUT', `/api/team/${id}`, data),
  deleteMember: (id)         => req('DELETE', `/api/team/${id}`),
  checkIn:      ()           => req('POST', '/api/team/attendance/checkin'),
  checkOut:     ()           => req('POST', '/api/team/attendance/checkout'),
  getAttendance:()           => req('GET', '/api/team/attendance/history'),

  getInvoices:   (params={}) => req('GET', '/api/invoices?' + new URLSearchParams(params)),
  createInvoice: (data)      => req('POST', '/api/invoices', data),
  updateInvoice: (id, data)  => req('PUT', `/api/invoices/${id}`, data),

  getCompany:    ()          => req('GET', '/api/company'),
  saveCompany:   (data)      => req('POST', '/api/company', data),

  getDashboard:  ()          => req('GET', '/api/dashboard/stats'),
};

export const setToken = (t)  => localStorage.setItem('ryzenos_token', t);
export const clearToken = () => localStorage.removeItem('ryzenos_token');
export const getUser = () => {
  const token = getToken();
  if (!token) return null;
  try { return JSON.parse(atob(token.split('.')[1])); } catch { return null; }
};
